import styled from "styled-components";

export const MessageBoxStyle = styled.div`
    /*position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);*/
    min-width: 160px;
    max-width: 800px;
    padding: 12px 16px;
    background: #000;
    border-radius: 8px;
    margin-top: 8px;
    box-sizing: border-box;
    &.bottomRight{
        left: initial;
        top: initial;
        transform: none;
    }
    .title{
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: #fff;
        word-break: break-word;
    }
    .icon{
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        margin-right: 14px;
    }
    .content{
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        line-height: 20px;
        padding-left: 34px;
        margin-top: 4px;
        word-break: break-word;
        max-height: 70vh;
        overflow-y: hidden;
    }
    .label{
        color: #fff;
    }
`;


export const BtnGroup = styled.div`
    grid-column-gap: 12px;
    margin-top: 20px;
    .btn{
        font-weight: 400;
    }
`;
